<template>
    <div class="SocialNav" :class="modifiers">
        <small class="SocialNav-label">
            <slot></slot>
        </small>
        <component
            v-for="item in items"
            :key="item.id"
            :is="getElem(item)"
            :href="item.url"
            :target="item.target"
            class="SocialNav-bttn"
            @click.stop="$emit('item-click', item.id)"
        >
            <svg class="SocialNav-icon">
                <use :xlink:href="`#${item.iconId}`"></use>
            </svg>
        </component>
    </div>
</template>

<script>
export default {
    name: 'SocialNav',
    props: {
        light: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            required: true,
        },
    },
    methods: {
        getElem(item) {
            return item.url ? 'a' : 'div'
        },
    },
    computed: {
        modifiers() {
            const { light } = this
            return {
                'SocialNav--light': light,
            }
        },
    },
}
</script>

<style src="styles/components/SocialNav.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/SocialNav.vue